import React, { useContext, useState } from 'react';
import Row from "react-bootstrap/Row";
import { Card, Col } from "react-bootstrap";
import { Context } from "../../index";
import { updateUserDataFront } from "../../http/userAPI"; // Используем вашу API-функцию
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserChangePass = () => {
    const { user } = useContext(Context);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handlePasswordChange = async (e) => {
        e.preventDefault();

        // Проверяем, что все поля заполнены (без лишних пробелов)
        if (!currentPassword.trim() || !newPassword.trim() || !confirmPassword.trim()) {
            toast.error("Please fill in all fields.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // Проверяем, что новый пароль совпадает с подтверждением
        if (newPassword !== confirmPassword) {
            toast.error("New password and confirmation do not match.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        try {
            const id = user.user.id; // Используем ID из store
            await updateUserDataFront(id, null, newPassword);

            toast.success("Password updated successfully.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            // Сбрасываем поля ввода
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            console.error("Error updating password:", error);
            const errorMsg = error.response?.data?.message || "Failed to update password. Please try again.";
            toast.error(errorMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    return (
        <Row className="g-3">
            <Col xs={12} md={6}>
                <Card className="shadow-sm p-0 bg-white small rounded">
                    <Card.Body>
                        <form onSubmit={handlePasswordChange}>
                            <h5 className="mb-4 text-muted">Change Password</h5>

                            <div className="mb-3">
                                <label htmlFor="currentPassword" className="form-label">Current Password:</label>
                                <input
                                    type="password"
                                    className="form-control form-control-sm border-secondary"
                                    id="currentPassword"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    placeholder="Enter current password"
                                />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="newPassword" className="form-label">New Password:</label>
                                <input
                                    type="password"
                                    className="form-control form-control-sm border-secondary"
                                    id="newPassword"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder="Enter new password"
                                />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="confirmPassword" className="form-label">Confirm New Password:</label>
                                <input
                                    type="password"
                                    className="form-control form-control-sm border-secondary"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm new password"
                                />
                            </div>

                            <button type="submit" className="btn btn-sm btn-success fw-bold text-white">
                                Update Password
                            </button>
                        </form>
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} md={6}>
                {/* Место под вторую колонку, если нужно */}
            </Col>
        </Row>
    );

};

export default UserChangePass;
